export const CIP_STATES = [
  {
    value: '-1',
    label: 'Todos'
  },
  {
    value: '21',
    label: 'Expirado'
  },
  {
    value: '22',
    label: 'Generado'
  },
  {
    value: '23',
    label: 'Pagado'
  },
  {
    value: '25',
    label: 'Eliminado'
  }
];
